// extracted by mini-css-extract-plugin
export default {"chat-modal":"styles_chat-modal__rs2VV","body":"styles_body__7f2+b"};